import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class RectangleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'length',
			'width',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			length: maximum_rectangle.get_length(),
			width: maximum_rectangle.get_width()
		};
	}

	get_labels(): Record<string, string> {
		const { length, width, height } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			length,
			width,
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			length: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
